// extracted by mini-css-extract-plugin
module.exports = {"root":"t_b9"};